var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRental(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8166)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8166",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8632 20.9773L26.4114 2.38997C26.0348 2.04612 25.5433 1.85547 25.0333 1.85547C24.5234 1.85547 24.0319 2.04612 23.6553 2.38997L3.20313 20.9773C2.99789 21.172 2.83347 21.4057 2.71946 21.6646C2.60545 21.9236 2.54413 22.2026 2.53906 22.4855V46.1312C2.539 46.3995 2.59179 46.6652 2.69442 46.9131C2.79704 47.161 2.9475 47.3863 3.13719 47.576C3.32689 47.7658 3.5521 47.9163 3.79997 48.019C4.04785 48.1217 4.31353 48.1746 4.58184 48.1746H45.4848C45.7531 48.1746 46.0188 48.1217 46.2666 48.019C46.5145 47.9163 46.7397 47.7658 46.9294 47.576C47.1191 47.3863 47.2696 47.161 47.3722 46.9131C47.4748 46.6652 47.5276 46.3995 47.5275 46.1312V22.4901C47.5223 22.2072 47.4609 21.9282 47.3469 21.6693C47.2329 21.4104 47.0686 21.1767 46.8635 20.9819L46.8632 20.9773Z",
    fill: "#FFC450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0214 17.2363C22.4375 17.2363 19.9117 18.0025 17.7633 19.438C15.6148 20.8735 13.9403 22.9139 12.9515 25.301C11.9627 27.6882 11.704 30.315 12.2081 32.8492C12.7121 35.3835 13.9564 37.7113 15.7834 39.5384C17.6105 41.3655 19.9383 42.6097 22.4725 43.1138C25.0068 43.6179 27.6336 43.3592 30.0207 42.3704C32.4079 41.3816 34.4483 39.7071 35.8838 37.5587C37.3193 35.4103 38.0856 32.8845 38.0856 30.3006C38.0856 28.585 37.7477 26.8861 37.0911 25.3011C36.4346 23.7161 35.4723 22.2759 34.2592 21.0628C33.0461 19.8496 31.6059 18.8873 30.0209 18.2308C28.4358 17.5742 26.737 17.2363 25.0214 17.2363Z",
    fill: "#3B965E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0317 39.2099L19.5711 31.1346L19.6072 29.5304C22.6353 29.7445 24.9874 29.4247 25.5472 26.5491L19.0864 26.5138L20.1323 24.7675L25.2906 24.8389C24.509 23.2117 22.3456 23.0104 18.9844 23.1287L20.1367 21.4186L31.0791 21.4062L29.9985 23.0935H26.9825C27.5094 23.5715 27.8536 24.2179 27.9562 24.9219L31.0918 24.8865L30.012 26.5606L27.9222 26.596C27.602 29.0979 25.2974 30.5747 22.3991 30.9187L28.8821 39.2271L26.0323 39.2148L26.0317 39.2099Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRental);
export default __webpack_public_path__ + "static/media/rental.19545e833f579b2f656143f9bd5927de.svg";
export { ForwardRef as ReactComponent };